import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Pill, PillColor } from '@shared/components/pill';

interface TagProps {
  label: string;
  color?: PillColor;
  archived?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

export function Tag({ label, color, archived, style, textStyle }: Readonly<TagProps>) {
  return (
    <Pill
      round
      italic={archived}
      backgroundColor={archived ? 'backgroundGrayLight' : color}
      style={style}
      textStyle={textStyle}
    >
      {label}
    </Pill>
  );
}
